<template>
  <div class="background" style="top:0; left:0; pointer-events: none">
    <template v-for="design in designs">
      <img class="background designOverlay" :src="srcPath(design)"/>
    </template>
  </div>
</template>

<script>
    export default {
      name: "design-dev-tools",

      mounted() {
        this.designOverlay();
      },
      data() {
        return {
          name: null,
          designs: [],
        };
      },
      watch: {
        // update designs when route changes
        '$route'(to, from) {
          this.name = to.name;
          this.designOverlay();
        },
      },
      methods: {
        designOverlay() {
          // debugger;
          const name = this.$router.history.current.name;
          this.designs = window.configMgr.getConfig().designs[name];
        },
        srcPath(fileName) {
          return `../../static/images/design/${fileName}`;
        },
      },
    }
</script>

<style scoped>
  .designOverlay{
    z-index: 99999;
    opacity: 0.5;
    pointer-events: none;
    visibility: visible;
  }
</style>



// WEBPACK FOOTER //
// Design-DevTools.vue?573830df